"use client";
import clsx from "clsx";
import { useRouter } from "next/navigation";
import React from "react";

interface PaginationProps {
  perPage: number;
  currentPage: number;
  entriesNumber: number;
  setPage?: (page: number) => void;
  initialEntries: boolean;
}

const Pagination: React.FC<PaginationProps> = ({
  perPage,
  currentPage,
  entriesNumber,
  setPage,
  initialEntries,
  //   onPageChange,
}) => {
  const totalPages = Math.ceil(entriesNumber / perPage);
  const router = useRouter();
  const handlePageChange = (page: number) => {
    if (page >= 1 && page <= totalPages) {
      if (!initialEntries && setPage) {
        // console.log("case1");
        setPage(page);
      } else {
        // console.log("case2");
        router.push(
          page === 1 ? `/publications` : `/publications/page/${page}`
        );
      }
    }
  };

  if (totalPages === 1) return null;

  return (
    <div className="flex justify-center mt-4 text-xs">
      <div className="flex justify-center border-b space-x-0.5">
        {/* <button
        className={`px-4 py-2 mx-1 border rounded ${
          currentPage === 1 ? "cursor-not-allowed opacity-50" : ""
        }`}
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        Précédente
      </button> */}
        {Array.from({ length: totalPages }, (_, index) => (
          <button
            key={`page-${index + 1}`}
            className={clsx(
              `px-1.5 py-2  border-b-2 font-medium`,
              currentPage === index + 1
                ? "text-brand-red border-b-brand-red font-medium"
                : "border-b-transparent  text-black/70 hover:text-black/90 hover:bg-gray-100"
            )}
            onClick={() => handlePageChange(index + 1)}
          >
            {index + 1}
          </button>
        ))}
        {/* <button
        className={`px-4 py-2 mx-1 border rounded ${
          currentPage === totalPages ? "cursor-not-allowed opacity-50" : ""
        }`}
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        Suivante
      </button> */}
      </div>
    </div>
  );
};

export default Pagination;
